"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_PROPOSAL_STATUSES = exports.ALL_PROPOSAL_TYPES = void 0;
exports.ALL_PROPOSAL_TYPES = [0, 1, 2, 3]; // [Suggestion, Proposal, Decision, Stream]
exports.ALL_PROPOSAL_STATUSES = [0, 1, 2]; // [Active, Cancelled, Executed]
